var Backbone, SupportOptimizedContactChannelsModel, SupportOptimizedContactChannelsTemplate,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Backbone = require('backbone');

SupportOptimizedContactChannelsTemplate = require('../../optimized_contact_channels.html.mustache');

SupportOptimizedContactChannelsModel = (function(superClass) {
  extend(SupportOptimizedContactChannelsModel, superClass);

  function SupportOptimizedContactChannelsModel() {
    return SupportOptimizedContactChannelsModel.__super__.constructor.apply(this, arguments);
  }

  SupportOptimizedContactChannelsModel.prototype.initialize = function() {
    return this.template = SupportOptimizedContactChannelsTemplate;
  };

  SupportOptimizedContactChannelsModel.prototype.toHash = function() {
    return this.toJSON();
  };

  SupportOptimizedContactChannelsModel.prototype.hidePreferencedContactChannel = function() {
    var optimizedContactChannels;
    optimizedContactChannels = [this.optimizephoneBtnElem(), this.optimizeEmailBtnElem()];
    removePreferredContactClass(optimizedContactChannels);
    return addBtnSecondaryClass(optimizedContactChannels);
  };

  SupportOptimizedContactChannelsModel.prototype.showPreferencedContactChannel = function(type) {
    var preferredContactElem;
    if (this.optimizedLiveChatVisible() || ($('.preferred-contact-channel', '.optimized-contact-channels-view').length > 0)) {
      return;
    }
    switch (type) {
      case "email":
        preferredContactElem = this.optimizeEmailBtnElem();
        break;
      case "phone":
        preferredContactElem = this.optimizephoneBtnElem();
    }
    if (preferredContactElem) {
      addPreferredContactClass(preferredContactElem);
      return removeBtnSecondaryClass(preferredContactElem);
    }
  };

  SupportOptimizedContactChannelsModel.prototype.optimizedLiveChatVisible = function() {
    return window.liveChatVisible($(".live-chat-container.optimized-contact-channel a img"));
  };

  SupportOptimizedContactChannelsModel.prototype.setOptimizedLiveChatDisplayCallBack = function(liveChatDisplayCallback) {
    return window.setLiveChatDisplayCallBack($(".live-chat-container.optimized-contact-channel a img"), liveChatDisplayCallback);
  };

  SupportOptimizedContactChannelsModel.prototype.optimizephoneBtnElem = function() {
    return $('.optimized-phone-btn');
  };

  SupportOptimizedContactChannelsModel.prototype.optimizeEmailBtnElem = function() {
    return $('.optimized-email-us');
  };

  SupportOptimizedContactChannelsModel.prototype.optimizedLiveChatContainer = function() {
    return $('.optimized-live-chat-container');
  };

  SupportOptimizedContactChannelsModel.prototype.emailRecommendationTextElement = function() {
    return $('.optimized-email-us-p');
  };

  SupportOptimizedContactChannelsModel.prototype.phoneRecommendationTextElement = function() {
    return $('.optimized-phone-p');
  };

  return SupportOptimizedContactChannelsModel;

})(Backbone.Model);

module.exports = SupportOptimizedContactChannelsModel;

//# sourceMappingURL=data:application/json;base64,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
